/**
 * Created by andrey on 11.08.2025
 */

cc.ActionInstant = function () {
    cc.FiniteTimeAction.prototype.constructor.call(this);
};

cc.ActionInstant.prototype = Object.assign(Object.create(cc.FiniteTimeAction.prototype), {
    constructor: cc.ActionInstant,

    isDone: function () {
        return true;
    },

    step: function () {
        this.update(1);
    },

    update: function () {
    },

    _autoFinalize: function () {
        if (this.target) {
            this.update();
        }
    }
});
